<template>
    <div class="list container-profile">
        <div class="list-wrapper" v-if="isLoaded && isHaveItem">
            <MenuItem
                v-for="(campaign, k) in campaigns"
                class="col-6 campaign-item"
                :key="k"
                :index="k"
                :campaign="campaign"
                :config="menuFunction"
            />
        </div>
        <div v-if="isLoaded && !isHaveItem" class="text-center">
            พบกันเร็วๆนี้
        </div>
    </div>
</template>
<script>
// component
import MenuItem from "./MenuItem.vue";
// helper
import Account from "@/helper/AccountHelper.js";
//service
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";

export default {
    name: "MenuList",
    components: {
        MenuItem
    },
    props: {
        isLoading: Boolean,
        initListConfig: Object,
        initFilterConfig: Object,
        busEvent: Object,
        menuFunction: Boolean
    },
    data: function() {
        return {
            campaigns: [],
            isLoaded: false,
            isHaveItem: true,

            //config
            listConfig: null,
            filterConfig: null,     
        };
    },
    created: function() {
        this.busEvent.$on("reInitList", this.reInitialList);
        this.listConfig = this.initListConfig;
        this.filterConfig = this.initFilterConfig;

        // this.getList();
        window.addEventListener("scroll", this.initialSeeMore);
    },
    mounted: function() {
        this.busEvent.$on("switchLang", this.switchLang);
    },
    beforeDestroy: function() {
        window.removeEventListener("scroll", this.initialSeeMore);
    },
    methods: {
        initialSeeMore: function() {
            if (
                window.scrollY + window.innerHeight + 10 >=
                document.body.scrollHeight
            ) {
                this.loadMore();
            }
        },
        getList() {
            return new Promise((resolve, reject) => {
                this.isLoaded = false;
                if (!this.listConfig.strConfigList) return;

                var strBzbsToken = Account.getToken();
                BzbsCampaign.apiGetCampaign(
                    strBzbsToken,
                    this.listConfig,
                    this.filterConfig
                ).subscribe(
                    campaigns => {
                        this.listConfig.intSkip += this.listConfig.defaultTopAmount;
                        //check is there are more campaign.
                        if (
                            campaigns &&
                            campaigns.length < this.listConfig.defaultTopAmount
                        )
                            this.listConfig.isSeeMoreEnable = false;

                        //reinitialize list if no skip.
                        if (
                            this.listConfig.intSkip ==
                            this.listConfig.defaultTopAmount
                        )
                            this.campaigns = [];

                        for (var campaign of campaigns) {
                            //TODO: Add GA Tracking.
                            this.campaigns.push(campaign);
                        }

                        this.isLoaded = true;
                        this.isHaveItem = this.campaigns.length > 0 ? true : false;
                        resolve(campaigns)
                    },
                    err => {
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        // this.hideLoading();
                        reject(err)
                    }
                );
            });
        },
        showLoading: function() {
            if (this.isLoading) return true;

            this.toggleLoading(true);

            return false;
        },
        hideLoading: function() {
            this.toggleLoading(false);
        },
        toggleLoading: function(isLoading) {
            this.$emit("toggleLoading", isLoading);
        },
        loadMore: function() {
            if (!this.listConfig.isSeeMoreEnable) return;
            if (this.showLoading()) return;

            setTimeout(() => {
                this.getList();
            }, 500);
        },
        reInitialList: function(data) {
            this.resetLoaded();
            this.listConfig = data.listConfig;
            this.filterConfig = data.filterConfig;
                
            // this.getList();
        },
        resetLoaded: function() {
            this.campaigns = [];
            this.isLoaded = false;
            this.isHaveItem = false;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/baseDisplay.scss";
@import "@/style/historypoint.scss";

.list {
    width: 100%;
    color: #fff;
    margin-top: -15px;

    .list-wrapper {
        @extend %display-flex;
        width: 100%;
    }

    .text-center {
        padding-top: 60px;
    }
}
</style>
